import { render, staticRenderFns } from "./GameData.vue?vue&type=template&id=19dd4ea9&scoped=true"
import script from "./GameData.vue?vue&type=script&lang=js"
export * from "./GameData.vue?vue&type=script&lang=js"
import style0 from "./GameData.vue?vue&type=style&index=0&id=19dd4ea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd4ea9",
  null
  
)

export default component.exports